module.exports = __webpack_public_path__ + "img/closeIsiBtn.f04b4d40.svg";